import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import Box from "./Box";
var calculateAspectRatio = function(width, height) {
    return "".concat((height / width * 100).toFixed(2), "%");
};
var AspectRatioBox = styled(Box).attrs(function(param) {
    var _$styles = param.$styles, $styles = _$styles === void 0 ? {} : _$styles, $width = param.$width, $height = param.$height;
    return {
        $styles: _object_spread({
            position: "relative",
            height: 0,
            overflow: "hidden",
            paddingTop: calculateAspectRatio($width, $height)
        }, $styles)
    };
}).withConfig({
    componentId: "sc-72cc0c6-0"
})(_templateObject());
export default AspectRatioBox;
